export default __webpack_public_path__ + "static/media/ic_workplace_blue2_48px.f6146c27.svg";